import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useRouteLocation, useLink } from 'react-router-stack';
import { showErrorToast, showToast } from '../../../actions/app-actions-types';
import useGame from '../../../utilities/hooks/game';
import I18n from '../../../utilities/locale';
import { getRouteObjByGame, isSmartPhone } from '../../../utilities/helper';
import Constants from '../../../constants';
import { v4 as uuidv4 } from 'uuid';
import ChooseCaptainMWeb from './index_mWeb';
import ChooseCaptainWeb from './index_web';

const ChooseCaptain = () => {
  const { fantasyMatchClick, gameType, setMyTeamList } = useGame();
  const navigate = useLink();
  const dispatch = useDispatch();
  const { state = {} } = useRouteLocation();
  const [selectedPlayer, setSelectedPlayer] = useState([] as any);
  const [captain, setCaptain] = useState('');
  const [captainData, setCaptainData] = useState({});
  const [viceCaptain, setViceCaptain] = useState('');
  const [viceCaptainData, setViceCaptainData] = useState({});
  const {
    teamData = {},
    item: matchItem = {},
    player,
    isClone = false,
    entryFee,
    contestId,
    isEdit,
    joinedMatch = false,
    bonusPercentage,
    isTeamSwitch = false,
    isFromCreateTeamButton = false,
    isFromMyTeam = false
  } = state;

  const { teamNumber = 1 } = teamData;

  const { teamA = {}, teamB = {} } = matchItem;
  useEffect(() => {
    const { captainId = '', viceCaptainId = '' } = teamData;

    const players = [] as any[];
    let obj = {};
    player.forEach((item: any) => {
      if (isClone || isEdit) {
        if (item.id === viceCaptainId) {
          obj = { ...item, viceCaptain: true, captain: false };
          setViceCaptain(viceCaptainId);
          setViceCaptainData(item);
        } else if (item.id === captainId) {
          obj = { ...item, viceCaptain: false, captain: true };
          setCaptain(captainId);
          setCaptainData(item);
        } else {
          obj = { ...item, viceCaptain: false, captain: false };
        }
      } else {
        obj = { ...item, viceCaptain: false, captain: false };
      }
      players.push(obj);
    });
    setSelectedPlayer(players);
  }, []);

  const onPressContinue = () => {
    const playerData = [...selectedPlayer];
    const players: any[] = [];
    let captainId = '',
      viceCaptainId = '';
    playerData.forEach((i) => {
      players.push({
        playerId: i.id,
        rating: i.rating,
        role: i.role,
        teamId: i.teamId
      });
      if (i.captain) {
        captainId = i.id;
      }
      if (i.viceCaptain) {
        viceCaptainId = i.id;
      }
    });

    if (captain === '') {
      dispatch(showErrorToast(I18n.t('PleaseSelectCaptain')));
    } else if (viceCaptain === '') {
      dispatch(showErrorToast(I18n.t('PleaseSelectViceCaptain')));
    } else {
      if (isEdit) {
        editTeamAPI(players, captainId, viceCaptainId);
      } else {
        createTeamAPI(players, captainId, viceCaptainId);
      }
    }
  };

  const selectedCaptain = (i: any) => {
    let data = [...selectedPlayer];
    data.forEach((item) => {
      if (item.playerId === i.playerId) {
        item.captain = true;
        setCaptain(item.playerId);
        setCaptainData(i);
        if (item.viceCaptain) {
          item.viceCaptain = false;
          setViceCaptain('');
          setViceCaptainData({});
        }
      } else {
        item.captain = false;
      }
    });
    setSelectedPlayer(data);
  };

  const selectedViceCaptain = (i: any) => {
    const data = [...selectedPlayer];
    data.forEach((item) => {
      if (item.playerId === i.playerId) {
        item.viceCaptain = true;
        setViceCaptain(item.playerId);
        setViceCaptainData(i);
        if (item.captain) {
          item.captain = false;
          setCaptain('');
          setCaptainData({});
        }
      } else {
        item.viceCaptain = false;
      }
    });
    setSelectedPlayer(data);
  };

  const createTeamAPI = (players: any[], captainId: string, viceCaptainId: string) => {
    const uniqueId = uuidv4();
    dispatch(showToast(I18n.t('teamCreateSuccessfully')));

    dispatch(
      setMyTeamList({
        matchId: matchItem['_id'],
        teamData: {
          ...teamData,
          players: players,
          captainId: captainId,
          viceCaptainId: viceCaptainId,
          captain: captainData,
          viceCaptain: viceCaptainData,
          id: uniqueId,
          _id: uniqueId
        }
      })
    );
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          completed: false,
          joined: false,
          joinedMatch: isFromCreateTeamButton ? false : joinedMatch,
          contestId,
          entryFee: entryFee,
          bonusPercentage,
          isTeamSwitch,
          isFromCreateTeamButton: false,
          isFromMyTeam: false
        }
      })
    );

    if (joinedMatch && !isFromMyTeam) {
      navigate.push(getRouteObjByGame(Constants.GameType.FANTASY_CRICKET)['my_teams'], {
        isFromCreateTeam: true
      });
    } else {
      navigate.go(-2);
    }
  };
  const editTeamAPI = (players: any[], captainId: string, viceCaptainId: string) => {
    dispatch(showToast(I18n.t('teamUpdatedSuccessfully')));
    dispatch(
      setMyTeamList({
        matchId: matchItem['_id'],
        teamId: teamData['id'],
        teamData: {
          ...teamData,
          players: players,
          captainId: captainId,
          viceCaptainId: viceCaptainId,
          captain: captainData,
          viceCaptain: viceCaptainData
        },
        isEdit: true
      })
    );

    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          completed: false,
          joined: false,
          joinedMatch: joinedMatch,
          contestId,
          entryFee: entryFee,
          bonusPercentage,
          isTeamSwitch
        }
      })
    );
    navigate.go(-2);
  };

  const onCalledDeadline = () => {
    navigate.push('/', { replace: true });
  };

  return (
    <>
      {isSmartPhone ? (
        <ChooseCaptainMWeb
          teamNumber={teamNumber}
          matchItem={matchItem}
          gameType={gameType}
          selectedPlayer={selectedPlayer}
          selectedCaptain={selectedCaptain}
          selectedViceCaptain={selectedViceCaptain}
          teamA={teamA}
          teamB={teamB}
          captain={captain}
          // PlayerType: PlayerType,
          viceCaptain={viceCaptain}
          captainData={captainData}
          viceCaptainData={viceCaptainData}
          onPressContinue={onPressContinue}
        />
      ) : (
        <ChooseCaptainWeb
          teamNumber={teamNumber}
          matchItem={matchItem}
          gameType={gameType}
          selectedPlayer={selectedPlayer}
          selectedCaptain={selectedCaptain}
          selectedViceCaptain={selectedViceCaptain}
          teamA={teamA}
          teamB={teamB}
          captain={captain}
          // PlayerType: PlayerType,
          viceCaptain={viceCaptain}
          captainData={captainData}
          viceCaptainData={viceCaptainData}
          onPressContinue={onPressContinue}
          onCalledDeadline={onCalledDeadline}
        />
      )}
    </>
  );
};
export default ChooseCaptain;
